import styled from "styled-components";

export const WhiteCardList = styled.div`
  display: grid;
  gap: 1rem;
  width: 100%;
`;
